<template>
    <header class="header">
        <h1>Tasks</h1>
    </header>
</template>

<script>
export default {
    name: "Header"
}
</script>

<style scoped>
    .header {
        background: none;
        color: pink;
        text-align: center;
        font-size: 24pt;
    }
</style>
